// extracted by mini-css-extract-plugin
module.exports = {"burgerIngredients":"burger-ingredients_burgerIngredients__2rXnZ","ingredients":"burger-ingredients_ingredients__1ayXP"};